module.exports = __webpack_public_path__ + "a61730925279150b15d43023c8dfbacc.jpg";